import { render, staticRenderFns } from "./VehicleProvisionRequestReport.vue?vue&type=template&id=e6c58382&scoped=true&"
import script from "./VehicleProvisionRequestReport.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionRequestReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c58382",
  null
  
)

export default component.exports
import {QCardSection,QItem,QInput,QIcon,QField,QBtn,QTooltip,QSelect} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QInput,QIcon,QField,QBtn,QTooltip,QSelect}, component.options.components || {})
